import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'address'
})
export class AddressPipe implements PipeTransform {

  public static transform(address: string, line: number = 0): string {
    let parts: string[] = address.split(',').map(i => i.trim());
    if (parts.length > 2) parts = [parts[0], parts.skip(1).distinct().join(', ')];

    return parts[line - 1] ? parts[line - 1] : '';
  }

  public transform(address: string, line: number = 0): string {
    return AddressPipe.transform(address, line);
  }
}
